import { useCommandBar } from "../hooks/useCommandBar";
import { Button } from "./Button";
import { Tooltip } from "./Tooltip";

export function SearchButton() {
  const { toggle } = useCommandBar();

  return (
    <Tooltip
      content={
        <>
          Search{" "}
          <span style={{ fontSize: 10, color: "var(--text-secondary)" }}>
            ⌘K
          </span>
        </>
      }
    >
      <Button
        variant="secondary"
        size="l"
        icon="search"
        onMouseDown={toggle}
        aria-label="Search"
      />
    </Tooltip>
  );
}
